export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-4">QwickBrain</h3>
            <p className="text-gray-400">
              AI-powered code intelligence for modern development
            </p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Product</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="https://qwickapps.com" className="hover:text-white transition">
                  QwickApps
                </a>
              </li>
              <li>
                <a href="https://qwickapps.com/pages/sign-up" className="hover:text-white transition">
                  Beta Signup
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Legal</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="https://qwickapps.com/privacy" className="hover:text-white transition">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://qwickapps.com/terms" className="hover:text-white transition">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; 2025 QwickApps, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
